import { history } from '../history';
import { UpdateUserPermissionsRequest } from './client/data-contracts';

const LOGIN_PATH = '/authentication/login';
const ACCESS_TOKEN_KEY = 'accessToken';
export function getAccessToken() {
  const accessToken = localStorage.getItem(ACCESS_TOKEN_KEY);
  return accessToken;
}

export function setAccessToken(token: string) {
  localStorage.setItem(ACCESS_TOKEN_KEY, token);
}

export function removeAccessToken() {
  localStorage.removeItem(ACCESS_TOKEN_KEY);
}

export interface UserData {
  email: string;
  id: string;
  username: string;
  isDeleted: boolean;
  isAdmin: boolean;
  permissions: UpdateUserPermissionsRequest['permissions'];
}
const USER_DATA_KEY = 'userData';
export function getUserData(): UserData | null {
  const serialized = localStorage.getItem(USER_DATA_KEY);
  if (!serialized) {
    return null;
  }
  return JSON.parse(serialized);
}

export function setUserData(userData: UserData) {
  const serialized = JSON.stringify(userData);
  localStorage.setItem(USER_DATA_KEY, serialized);
}

export function removeUserData() {
  localStorage.removeItem(USER_DATA_KEY);
}

export function logout() {
  removeAccessToken();
  removeUserData();
}

export function login(userData: UserData, accessToken: string) {
  setUserData(userData);
  setAccessToken(accessToken);
}

/**
 * Handles an unauthorized (401) / expired session: clears the stored
 * credentials and redirects to the login page. Wired here (rather than inside
 * a route effect) so it works for every request path — public routes, first
 * paint and the axios modules — from a single, reliable place.
 */
export function onUnauthorized() {
  removeAccessToken();
  removeUserData();
  if (history.location.pathname !== LOGIN_PATH) {
    history.push(LOGIN_PATH);
  }
}

export const useAuthentication = () => {};
